import Layout from '../../internal/Layout.vue'
import logs from './logs.vue'

const logsRoutes = {
  component: Layout,
  children: [
    {
      name: 'logs',
      path: '/',
      component: logs,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresCoordOp: true,
      },
    },
  ],
}

export default logsRoutes
